/** Styles of `SpecialChargesIcon.tsx`. */
import { Typography } from "@ryerson/frontend.typography";
import styled from "@emotion/styled";

/** Positions the icon (`top` offset) and forces its SVG to 18px in `iconColor`. */
export const TooltipContainer = styled.div<{ iconColor: string, top: string }>`
    margin-left: 4px;
    top: ${(props) => (props.top)};
    position: relative;

    svg {
        color: ${(props) => props.iconColor};
        display: block !important;
        height: 18px !important;
        width: 18px !important;
    }
`;

/** The tooltip text; at least 200px wide on mobile. */
export const TooltipContent = styled(Typography)<{isMobile: boolean}>`
    font-size: 14px;
    line-height: 20px;
    min-width: ${(props) => (props.isMobile ? "200px" : "none")};
    padding: 5px;
    text-align: left;
`;